import useAsyncData from "../../../hooks/use-async-data";
import partnerService from "../partner.service";
import PartnerDetails from "./partner-details";
import PartnerDetailsParams from "./partner-details-params";

const usePartnerDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<PartnerDetails | null>(null);

  const load = async (
    params: PartnerDetailsParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const partnerDetails = await partnerService.getDetails(params, signal);

      setData(partnerDetails);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default usePartnerDetails;
